<template>
  <div>
    <div class="bio-line-admin flex items-center">
      <input v-model="line.text" class="flex-auto w-2/3" />
      <div class="flex-initial">
        <button
          v-if="line.image"
          class="leading-none"
          @click.prevent="removeImage"
        >
          ❌
        </button>
        <dropzone
          :base-path="MEDIA_PATH"
          :base-url="IMAGES_URL"
          :preview-url="line.image && line.image.url"
          class="mr-1"
          @success="uploadSuccess($event)"
        />
        <button class="leading-none" @click.prevent="addClick">
          ➕
        </button>
        <button class="leading-none" @click.prevent="removeClick">
          ➖
        </button>
      </div>
    </div>
    <draggable :list="line.subtext" handle=".handle">
      <div
        v-for="(line, i) in line.subtext"
        :key="`subline-admin-${i}`"
        class="relative pl-6 ml-6 md:ml-12"
      >
        <span class="handle absolute left-0 leading-none">👉</span>
        <bio-line-admin :line.sync="line" @remove="remove(i)" />
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Dropzone from '@/components/admin/Dropzone.vue'
import { MEDIA_PATH, IMAGES_URL } from 'spencer'

export default {
  name: 'BioLineAdmin',

  components: {
    draggable,
    Dropzone
  },

  props: {
    line: {
      default: () => {},
      type: Object
    }
  },

  data: () => ({
    MEDIA_PATH,
    IMAGES_URL
  }),

  methods: {
    addClick() {
      this.add()
    },

    removeClick() {
      this.$emit('remove')
    },

    uploadSuccess({ url, size }) {
      this.line.image = { url, ...size }
    },

    removeImage() {
      this.line.image = null
    },

    add() {
      this.line.subtext.push({
        text: '',
        image: null,
        subtext: []
      })
    },

    remove(index) {
      this.line.subtext.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.bio-line-admin:hover {
  background-color: #ccc;
}
</style>
